/*###########################################################################
// Scroll to
//#########################################################################*/

import { scrollTo } from "../utilities/_scrollTo"

const scrollToSection = {
	config: {
		button: '.scroll-to'
	},

	elements: {},

	init() {
		const self = this

		self.scrollToOnLoad()
		self.scrollToSection()
	},

	scrollToOnLoad() {
		const scrollEl = document.querySelector('[data-scroll-to-on-load="true"]');

		if (scrollEl !== null) {
			const headerHeight = document.querySelector('.header').offsetHeight;
			scrollTo(scrollEl, -headerHeight)
		}
	},

	scrollToSection() {
		const self = this
		const elements = document.querySelectorAll('[data-scroll-to]')

		// Loop through each element and add the event listener
		elements.forEach(element => {
			element.addEventListener('click', function (e) {
				e.preventDefault()
				// Get the target section's ID from the data attribute
				const self = this
				const targetId = self.getAttribute('data-scroll-to');


				// Use querySelector to get a single element
				const targetSection = document.querySelector(`${targetId}`)
				const headerHeight = document.querySelector('.header').clientHeight


				scrollTo(targetSection, -headerHeight)
			});
		});
	}
}

initComponent(() => {
	scrollToSection.init()
})

